export default __webpack_public_path__ + "static/lgbtq-pr-sj-3-a4a47e6455793fa357cf4f056d276b06.jpg";